<template>
  <button
    class="btn place-bet-btn w-75"
    @click="tryPlaceBet()"
    :disabled="betPlaceStatus.loading || isPickCountNotReached || disablePlaceBetButton"
    :class="{ 'btn-loading-anim': betPlaceStatus.loading }"
    v-if="selectedType !== ''"
  >
    <span v-if="!betPlaceStatus.loading">
      <span>
        <i class="icon icon-bonuses" style="font-size: 20px;"></i>
        {{ $t('BetSlip.Place Free Bet') }}
      </span>
    </span>
    <i class="fa fa-spin fa-spinner" v-if="betPlaceStatus.loading"></i>
  </button>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import { ExternalWagerLoginTypes, LoginTypes } from '@/utils/enums';

export default {
  props: ['betOptionsResponse', 'disablePlaceBetButton'],
  computed: {
    ...mapState({
      selectedType: state => state.betSlip.selectedType,
      selections: state => state.betSlip.selections,
      betPlaceStatus: state => state.betSlip.betPlaceStatus,
      loginType: state => state.player.loginType,
      selectedFreeWager: state => state.freeWagerStore.selectedFreeWager,
    }),
    isLimitsExceed() {
      return this.checkValidity();
    },
    isPickCountNotReached() {
      if (this.selectedFreeWager.id) {
        const betsCount = this.selections.size;
        const allowedPickCount = parseInt(this.selectedFreeWager.pick_count);
        if (betsCount < allowedPickCount && allowedPickCount > 0) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    ...mapActions({
      placeBetUnconfirmed: 'betSlip/placeBetUnconfirmed',
    }),
    ...mapMutations({
      setShowLoginNeedModal: 'betSlip/setShowLoginNeedModal',
    }),
    ...mapMutations('betSlip', ['setValidity']),
    canConfirmBet() {
      return this.loginType === LoginTypes.Player;
    },
    checkValidity() {
      let valid = true;
      this.betOptionsResponse.forEach(bet => {
        const risk = parseFloat(bet.bet.input_risk_amount);
        const win = parseFloat(bet.bet.input_win_amount || '0');
        if (isNaN(risk) || isNaN(win)) valid = false;
        if (!bet.options) valid = false;
        else if (!bet.options.limits) valid = false;
        else if (risk < bet.options.limits.min_bet) valid = false;
        else if (risk > bet.options.limits.max_bet) valid = false;
      });
      return valid;
    },
    tryPlaceBet() {
      const vali = this.checkValidity();
      this.setValidity(vali);
      if (this.canConfirmBet()) {
        this.placeBetUnconfirmed();
      }
    },
  },
};
</script>
